import { daysInCurrentMonth } from "../appconfig/AppHelper";
import { emailPattern, phonePattern, postalCodePattern } from "../appconfig/Settings";

// login validation
export const LoginValidate = (inputDetail: any) => {
  let isError: boolean = false;

  let errorObj: any = {};

  let errors: any = {};

  if (window.cn(inputDetail.email) && !window.cb(inputDetail.email)) {
    errors = { ...errors, email: "Enter Email *" };
    isError = true;
  } else if (!emailPattern.test(inputDetail.email)) {
    errors = { ...errors, email: "Enter Valid Email*" };
    isError = true;
  } else {
    errors = { ...errors, email: "" };
  }

  if (window.cn(inputDetail.password) && !window.cb(inputDetail.password)) {
    errors = { ...errors, password: "Enter Password *" };
    isError = true;
  } else {
    errors = { ...errors, password: "" };
  }

  errorObj = { errors, isError };

  return errorObj;
};

// user add validate
export const validateUserForm = (inputDetail: any) => {
  let errors: any = {};
  let isError = false;
  if (window.cn(inputDetail.first_name) && !window.cb(inputDetail.first_name)) {
    errors.first_name = "Enter First Name *";
    isError = true;
  }
  if (window.cn(inputDetail.last_name) && !window.cb(inputDetail.last_name)) {
    errors.last_name = "Enter Last Name *";
    isError = true;
  }
  if (window.cn(inputDetail.email) && !window.cb(inputDetail.email)) {
    errors.email = "Enter Email *";
    isError = true;
  } else if (!emailPattern.test(inputDetail.email)) {
    errors.email = "Enter Valid Email *";
    isError = true;
  }
  if (window.cn(inputDetail.phone) && !window.cb(inputDetail.phone)) {
    errors.phone = "Enter Phone *";
    isError = true;
  } else if (!phonePattern.test(inputDetail.phone)) {
    errors.phone = "Enter Valid Phone *";
    isError = true;
  }
  if (window.cn(inputDetail.client_charge_payment_by) && !window.cb(inputDetail.client_charge_payment_by)) {
    errors.client_charge_payment_by = "Select Client Charge Payment By *";
    isError = true;
  }
  if (window.cn(inputDetail.postal_code) && !window.cb(inputDetail.postal_code)) {
    errors.postal_code = "Enter Postal Code *";
    isError = true;
  } else if (!postalCodePattern.test(inputDetail.postal_code)) {
    errors.postal_code = "Enter Valid Postal Code *";
    isError = true;
  }
  if (window.cn(inputDetail.address) && !window.cb(inputDetail.address)) {
    errors.address = "Enter Address *";
    isError = true;
  }
  return { errors, isError };
};

// client add validate
export const validateClientForm = (inputDetail: any, isEdit: any, user_id: any, userRole: any, isSchemeChanged: any = false) => {
  let errors: any = {};
  let isError = false;
  if (window.cn(inputDetail.company_name) && !window.cb(inputDetail.company_name)) {
    errors.company_name = "Enter Company Name *";
    isError = true;
  }
  if (window.cn(inputDetail.email) && !window.cb(inputDetail.email)) {
    errors.email = "Enter Email *";
    isError = true;
  } else if (!emailPattern.test(inputDetail.email)) {
    errors.email = "Enter Valid Email *";
    isError = true;
  }

  if (!isEdit && window.cn(inputDetail.client_payroll_starts_from) && !window.cb(inputDetail.client_payroll_starts_from)) {
    errors.client_payroll_starts_from = "Select Client Payroll Start From *";
    isError = true;
  }
  if (window.cn(inputDetail.postal_code) && !window.cb(inputDetail.postal_code)) {
    errors.postal_code = "Enter Postal Code *";
    isError = true;
  } else if (!postalCodePattern.test(inputDetail.postal_code)) {
    errors.postal_code = "Enter Valid Postal Code *";
    isError = true;
  }
  if (window.cn(inputDetail.phone) && !window.cb(inputDetail.phone)) {
    errors.phone = "Enter Phone *";
    isError = true;
  } else if (!phonePattern.test(inputDetail.phone)) {
    errors.phone = "Enter Valid Phone *";
    isError = true;
  }
  if (window.cn(inputDetail.address) && !window.cb(inputDetail.address)) {
    errors.address = "Enter Address *";
    isError = true;
  }
  if (window.cn(inputDetail.province) && !window.cb(inputDetail.province)) {
    errors.province = "Select Province *";
    isError = true;
  }
  if (window.cn(inputDetail.city) && !window.cb(inputDetail.city)) {
    errors.city = "Enter City *";
    isError = true;
  }
  if (!isEdit && !user_id && userRole != "User" && window.cn(inputDetail.user_head) && !window.cb(inputDetail.user_head)) {
    errors.user_head = "Select Supervisor *";
    isError = true;
  }
  if (window.cn(inputDetail.pay_schema) && !window.cb(inputDetail.pay_schema)) {
    errors.pay_schema = "Select Pay Scheme *";
    isError = true;
  }

  if (!isEdit && inputDetail?.custom_bi_weekly === true) {
    if (window.cn(inputDetail.bi_weekly_start_date) && !window.cb(inputDetail.bi_weekly_start_date)) {
      errors.bi_weekly_start_date = "Select Cycle Start Date *";
      isError = true;
    }
  }

  if (isEdit && isSchemeChanged) {
    if (window.cn(inputDetail.effective_date) && !window.cb(inputDetail.effective_date)) {
      errors.effective_date = "Select Effective Date *";
      isError = true;
    }
  }
  // if (
  //   userRole != "User" &&
  //   window.cn(inputDetail?.client_subs_month_year) &&
  //   !window.cb(inputDetail?.client_subs_month_year)
  // ) {
  //   errors.client_subs_month_year = "Select Client Payment Start Date *";
  //   isError = true;
  // }
  if (inputDetail.pay_schema === "Monthly" || inputDetail.pay_schema === "Semi Monthly") {
    if (window.cn(inputDetail?.paycheck) && !window.cb(inputDetail?.paycheck)) {
      errors.paycheck = "Enter PayCheque Days *";
      isError = true;
    } else if (Number(inputDetail?.paycheck) > daysInCurrentMonth()) {
      errors.paycheck = `Enter PayCheque day less than or equal to ${daysInCurrentMonth()} *`;
      isError = true;
    }
  }
  if (window.cn(inputDetail.client_charge) && !window.cb(inputDetail.client_charge)) {
    errors.client_charge = "Enter Client Charge *";
    isError = true;
  } else if (Number(inputDetail?.client_charge) > 15) {
    errors.client_charge = "Client Charge Must Be Less Than $15";
    isError = true;
  } else if (Number(inputDetail?.client_charge) < 9.99) {
    errors.client_charge = "Client Charge Must Be Greater Than $9.99";
    isError = true;
  }
  if (window.cn(inputDetail.bussiness_number) && !window.cb(inputDetail.bussiness_number)) {
    errors.bussiness_number = "Enter Business number *";
    isError = true;
  } else if (inputDetail.bussiness_number?.length != 13) {
    errors.bussiness_number = "Enter Valid Business number *";
    isError = true;
  }
  return { errors, isError };
};

// Employee add validate
export const validateEmployeeForm = (inputDetail: any, isEdit: any,) => {
  let errors: any = {};
  let isError = false;

  if (window.cn(inputDetail.first_name) && !window.cb(inputDetail.first_name)) {
    errors.first_name = "Enter First Name *";
    isError = true;
  }

  if (window.cn(inputDetail.last_name) && !window.cb(inputDetail.last_name)) {
    errors.last_name = "Enter Last Name *";
    isError = true;
  }

  if (window.cn(inputDetail.email) && !window.cb(inputDetail.email)) {
    errors.email = "Enter Email *";
    isError = true;
  } else if (!emailPattern.test(inputDetail.email)) {
    errors.email = "Enter Valid Email *";
    isError = true;
  }

  // if (window.cn(inputDetail.occupation) && !window.cb(inputDetail.occupation)) {
  //   errors.occupation = "Enter Occupation *";
  //   isError = true;
  // }

  if (window.cn(inputDetail.postal_code) && !window.cb(inputDetail.postal_code)) {
    errors.postal_code = "Enter Postal Code *";
    isError = true;
  } else if (!postalCodePattern.test(inputDetail.postal_code)) {
    errors.postal_code = "Enter Valid Postal Code *";
    isError = true;
  }
  if (window.cn(inputDetail.vaccation_payout) && !window.cb(inputDetail.vaccation_payout)) {
    errors.vaccation_payout = "Enter Vacation Payout*";
    isError = true;
  } else if (/[^0-9.]/.test(inputDetail.vaccation_payout)) {
    errors.vaccation_payout = "Enter valid Payout *";
    isError = true;
  }

  if (window.cn(inputDetail.sin_number) && !window.cb(inputDetail.sin_number)) {
    errors.sin_number = "Enter SIN Number *";
    isError = true;
  } else if (!/^\d{9}$/.test(inputDetail.sin_number)) {
    errors.sin_number = "SIN Number must be exactly 9 digits";
    isError = true;
  }

  if (window.cn(inputDetail.province) && !window.cb(inputDetail.province)) {
    errors.province = "Select Province *";
    isError = true;
  }
  if (window.cn(inputDetail.city) && !window.cb(inputDetail.city)) {
    errors.city = "Enter City *";
    isError = true;
  }
  if (window.cn(inputDetail.joining_date) && !window.cb(inputDetail.joining_date)) {
    errors.joining_date = "Enter Joining Date *";
    isError = true;
  }
  if (window.cn(inputDetail.date_of_birth) && !window.cb(inputDetail.date_of_birth)) {
    errors.date_of_birth = "Enter Date of Birth *";
    isError = true;
  }

  if (window.cn(inputDetail.phone) && !window.cb(inputDetail.phone)) {
    errors.phone = "Enter Phone *";
    isError = true;
  } else if (!phonePattern.test(inputDetail.phone)) {
    errors.phone = "Enter Valid Phone *";
    isError = true;
  }
  if (window.cn(inputDetail.wage) && !window.cb(inputDetail.wage)) {
    errors.wage = `${inputDetail.is_salary === true ? "Enter Salary Amount *" : "Enter Wage *"}`
    isError = true;
  } else if (/[^0-9.]/.test(inputDetail.wage)) {
    errors.wage = `${inputDetail.is_salary === true ? "Enter valid Salary Amount *" : "Enter valid wage *"}`
    isError = true;
  }

  if (window.cn(inputDetail.tax_deduction) && !window.cb(inputDetail.tax_deduction)) {
    errors.tax_deduction = "Enter tax deduction *";
    isError = true;
  } else if (/[^0-9.]/.test(inputDetail.tax_deduction)) {
    errors.tax_deduction = "Enter valid Tax *";
    isError = true;
  }
  if (window.cn(inputDetail.city) && !window.cb(inputDetail.city)) {
    errors.city = "Enter City *";
    isError = true;
  }

  if (window.cn(inputDetail.address) && !window.cb(inputDetail.address)) {
    errors.address = "Enter Street Address *";
    isError = true;
  }
  return { errors, isError };
};

// client charge validate
export const validateChargeStatus = (charge_paid: any) => {
  let errors: any = {};
  let isError = false;

  if (window.cn(charge_paid)) {
    errors.charge_paid = "Please select if the charge is paid *";
    isError = true;
  }
  return { errors, isError };
};

// validate working hours
export const validateWorkingHoursForm = (inputData: any) => {
  let errors: any = {};
  let isError = false;

  Object.keys(inputData).forEach((id: any) => {
    const value = inputData[id];

    if (window.cn(value)) {
      errors[id] = "Enter Working Hours *";
      isError = true;
    } else if (isNaN(Number(value))) {
      errors[id] = "Enter Valid Hours *";
      isError = true;
    }
  });

  return { errors, isError };
};

// validate PAyrollForm
export const validatePayrollForm = (inputDetail: any) => {
  let errors: any = {};
  let isError = false;
  if (window.cn(inputDetail) && !window.cb(inputDetail)) {
    errors.hour = "Enter Working hour *";
    isError = true;
  }
  return { errors, isError };
};

// change password validate
export const ChangePasswordValidate = (inputDetail: any) => {
  let isError = false;
  const errors: any = {};

  if (window.cn(inputDetail.currentPassword) && !window.cb(inputDetail.currentPassword)) {
    errors.currentPassword = "Current Password is required *";
    isError = true;
  }
  if (window.cn(inputDetail.newPassword) && !window.cb(inputDetail.newPassword)) {
    errors.newPassword = "New Password is required *";
    isError = true;
  }
  if (window.cn(inputDetail.confirmPassword) && !window.cb(inputDetail.confirmPassword)) {
    errors.confirmPassword = "Confirm Password is required *";
    isError = true;
  } else if (inputDetail.newPassword && inputDetail.confirmPassword && inputDetail.newPassword !== inputDetail.confirmPassword) {
    errors.confirmPassword = "Passwords do not match *";
    isError = true;
  }
  return { errors, isError };
};

// holiday validation
export const HolidayValidate = (inputDetail: any) => {
  let isError = false;
  const errors: any = {};

  if (window.cn(inputDetail.name) && !window.cb(inputDetail.name)) {
    errors.name = "Holiday name is required *";
    isError = true;
  }
  if (window.cn(inputDetail.date) && !window.cb(inputDetail.date)) {
    errors.date = "Select holiday Date *";
    isError = true;
  }
  return { errors, isError };
};

// validastion for contact us

export const ContactUSValidation = (inputDetail: any) => {
  let isError = false;
  const errors: any = {};

  if (window.cn(inputDetail?.name) && !window.cb(inputDetail?.name)) {
    errors.name = "Name is required *";
    isError = true;
  }
  if (window.cn(inputDetail?.email) && !window.cb(inputDetail?.email)) {
    errors.email = "Enter Email *";
    isError = true;
  } else if (!emailPattern.test(inputDetail?.email)) {
    errors.email = "Enter Valid Email *";
    isError = true;
  }
  if (window.cn(inputDetail?.mobile) && !window.cb(inputDetail?.mobile)) {
    errors.mobile = "Enter Phone Number*";
    isError = true;
  } else if (!phonePattern.test(inputDetail?.mobile)) {
    errors.mobile = "Enter Valid Phone *";
    isError = true;
  }
  if (window.cn(inputDetail?.message) && !window.cb(inputDetail?.message)) {
    errors.message = "Enter Message *";
    isError = true;
  }
  return { errors, isError };
};

export const payrollNumberValidate = (inputDetail: any) => {
  let isError = false;
  const errors: any = {};

  if (window.cn(inputDetail.payroll_no) && !window.cb(inputDetail.payroll_no)) {
    errors.payroll_no = "Enter Payroll Number *";
    isError = true;
  }
  return { errors, isError };
};

export const salesTaxValidate = (inputDetail: any) => {
  let isError = false;
  const errors: any = {};

  if (window.cn(inputDetail.name) && !window.cb(inputDetail.name)) {
    errors.name = "Enter Sales Tax Name *";
    isError = true;
  }
  if (window.cn(inputDetail.value) && !window.cb(inputDetail.value)) {
    errors.value = "Enter Sales Tax Percentage *";
    isError = true;
  }
  return { errors, isError };
};
export const ServiceNameValidate = (inputDetail: any) => {
  let isError = false;
  const errors: any = {};

  if (window.cn(inputDetail.name) && !window.cb(inputDetail.name)) {
    errors.name = "Enter Service Name *";
    isError = true;
  }
  return { errors, isError };
};

// invoice form validation

export const invoiceFormValidate = (inputDetail: any, serviceItemArray: any, date: any, dueDate: any) => {
  let isError: boolean = false;
  let errorObj: any = {};
  let errors: any = {};

  // if (window.cn(inputDetail?.bill_to) && !window.cb(inputDetail?.bill_to)) {
  //   errors.bill_to = "Enter Bill To *";
  //   isError = true;
  // }

  // if (window.cn(inputDetail?.bill_address) && !window.cb(inputDetail?.bill_address)) {
  //   errors.bill_address = "Enter Address *";
  //   isError = true;
  // }

  // if (window.cn(inputDetail.bill_email) && !window.cb(inputDetail.bill_email)) {
  //   errors.bill_email = "Enter Email *";
  //   isError = true;
  // } else if (!emailPattern.test(inputDetail.bill_email)) {
  //   errors.bill_email = "Enter Valid Email *";
  //   isError = true;
  // }

  // if (window.cn(inputDetail.bill_phone) && !window.cb(inputDetail.bill_phone)) {
  //   errors.bill_phone = "Enter Phone Number *";
  //   isError = true;
  // } else if (!phonePattern.test(inputDetail.bill_phone)) {
  //   errors.bill_phone = "Enter Valid Phone *";
  //   isError = true;
  // }

  if (window.cn(date) && !window.cb(date)) {
    errors.date = "Enter Date *";
    isError = true;
  }

  if (window.cn(dueDate) && !window.cb(dueDate)) {
    errors.due_date = "Enter Due Date *";
    isError = true;
  }

  if (window.cn(inputDetail?.terms_of_payment) && !window.cb(inputDetail?.terms_of_payment)) {
    errors.terms_of_payment = "Enter Terms of Payment *";
    isError = true;
  }

  serviceItemArray.forEach((item: any, index: any) => {
    if (window.cn(item.service) && !window.cb(item.service)) {
      errors[`service_${index}`] = "Enter Service Name*";
      isError = true;
    } else {
      errors[`service_${index}`] = "";
    }
    if (window.cn(item.quantity) && !window.cb(item.quantity)) {
      errors[`quantity_${index}`] = "Enter Quantity*";
      isError = true;
    } else {
      errors[`quantity_${index}`] = "";
    }
    if (window.cn(item.rate) && !window.cb(item.rate)) {
      errors[`rate_${index}`] = "Enter Rate*";
      isError = true;
    } else {
      errors[`rate_${index}`] = "";
    }

    if (window.cn(item.gst_hst) && !window.cb(item.gst_hst)) {
      errors[`gst_hst_${index}`] = "Select Tax*";
      isError = true;
    } else {
      errors[`gst_hst_${index}`] = "";
    }
    // if (window.cn(item.description) && !window.cb(item.description)) {
    //   errors[`description_${index}`] = "Enter description*";
    //   isError = true;
    // } else {
    //   errors[`description_${index}`] = "";
    // }
  });

  errorObj = { errors, isError };

  return errorObj;
};

// validate invoice payee form
export const validateInvoicePayeeForm = (inputDetail: any) => {
  let errors: any = {};
  let isError = false;
  if (window.cn(inputDetail.bill_to) && !window.cb(inputDetail.bill_to)) {
    errors.bill_to = "Enter Bill To Name *";
    isError = true;
  }

  if (window.cn(inputDetail.bill_email) && !window.cb(inputDetail.bill_email)) {
    errors.bill_email = "Enter Email *";
    isError = true;
  } else if (!emailPattern.test(inputDetail.bill_email)) {
    errors.bill_email = "Enter Valid Email *";
    isError = true;
  }
  if (window.cn(inputDetail.bill_phone) && !window.cb(inputDetail.bill_phone)) {
    errors.bill_phone = "Enter Phone *";
    isError = true;
  } else if (!phonePattern.test(inputDetail.bill_phone)) {
    errors.bill_phone = "Enter Valid Phone *";
    isError = true;
  }

  if (window.cn(inputDetail.bill_address) && !window.cb(inputDetail.bill_address)) {
    errors.bill_address = "Enter Address *";
    isError = true;
  }

  if (window.cn(inputDetail.payment_type) && !window.cb(inputDetail.payment_type)) {
    errors.payment_type = "Select Payment Method *";
    isError = true;
  }

  if (inputDetail.payment_type && inputDetail.payment_type !== "bank_transfer") {
    if (window.cn(inputDetail.payment_info) && !window.cb(inputDetail.payment_info)) {
      if (inputDetail.payment_type === "e_transfer") {
        errors.payment_info = "Enter E-transfer Email *";
      } else if (inputDetail.payment_type === "payment_link") {
        errors.payment_info = "Enter Payment Link *";
      } else {
        errors.payment_info = "Enter Detail *";
      }
      isError = true;
    }
  }

  if (inputDetail.payment_type === "bank_transfer") {
    if (window.cn(inputDetail.bank_name) && !window.cb(inputDetail.bank_name)) {
      errors.bank_name = "Enter Bank Name *";
      isError = true;
    }
    if (window.cn(inputDetail.institution_number) && !window.cb(inputDetail.institution_number)) {
      errors.institution_number = "Enter Institution Number *";
      isError = true;
    }
    if (window.cn(inputDetail.transit_number) && !window.cb(inputDetail.transit_number)) {
      errors.transit_number = "Enter Transit Number *";
      isError = true;
    }
    if (window.cn(inputDetail.bank_account_number) && !window.cb(inputDetail.bank_account_number)) {
      errors.bank_account_number = "Enter Account Number *";
      isError = true;
    }
  }

  return { errors, isError };
};

// payment received date in model which is in column on toggle a inputswitch
export const validatePaymentReceived = (paymentDate: any) => {
  let errors: any = {};
  let isError = false;

  if (window.cn(paymentDate) && !window.cb(paymentDate)) {
    errors.paymentDate = "Enter Payment Received Date";
    isError = true;
  }

  return { errors, isError };
};

// validate sub contractor detail
export const subContractorDetailForm = (inputDetail: any) => {
  let errors: any = {};
  let isError = false;
  if (window.cn(inputDetail.name) && !window.cb(inputDetail.name)) {
    errors.name = "Enter Name *";
    isError = true;
  }

  if (window.cn(inputDetail.email) && !window.cb(inputDetail.email)) {
    errors.email = "Enter Email *";
    isError = true;
  } else if (!emailPattern.test(inputDetail.email)) {
    errors.email = "Enter Valid Email *";
    isError = true;
  }
  if (window.cn(inputDetail.phone) && !window.cb(inputDetail.phone)) {
    errors.phone = "Enter Phone *";
    isError = true;
  } else if (!phonePattern.test(inputDetail.phone)) {
    errors.phone = "Enter Valid Phone *";
    isError = true;
  }

  if (window.cn(inputDetail.address) && !window.cb(inputDetail.address)) {
    errors.address = "Enter Address *";
    isError = true;
  }
  // if (window.cn(inputDetail.sin_no) && !window.cb(inputDetail.sin_no)) {
  //   errors.sin_no = "Enter Sin No OR Business No *";
  //   isError = true;
  // }
  // if (window.cn(inputDetail.gst_no) && !window.cb(inputDetail.gst_no)) {
  //   errors.gst_no = "Enter GST Number *";
  //   isError = true;
  // }
  return { errors, isError };
};

// validate sub contractor payment detail
export const validateSubContractorPayment = (inputDetail: any, date: any, paymentDate: any, serviceItemArray: any) => {
  let errors: any = {};
  let isError = false;
  // if (window.cn(inputDetail.amount) && !window.cb(inputDetail.amount)) {
  //   errors.amount = "Enter Amount *";
  //   isError = true;
  // }

  // if (window.cn(inputDetail.hour) && !window.cb(inputDetail.hour)) {
  //   errors.hour = "Enter Quantity / Hour *";
  //   isError = true;
  // }

  // if (inputDetail?.deduction !== null && inputDetail?.deduction !== undefined && typeof inputDetail?.deduction !== "string") {
  //   if (window.cn(inputDetail?.deduction_notes) && !window.cb(inputDetail?.deduction_notes)) {
  //     errors.deduction_notes = "Enter Deduction Remark";
  //     isError = true;
  //   }
  // } else {
  //   errors.deduction_notes = "";
  // }

  if (window.cn(inputDetail.gst_added) && !window.cb(inputDetail.gst_added)) {
    errors.gst_added = "Select gst included or not *";
    isError = true;
  }

  if (window.cn(inputDetail.payment_mode) && !window.cb(inputDetail.payment_mode)) {
    errors.payment_mode = "Select payment method *";
    isError = true;
  }

  if (window.cn(date) && !window.cb(date)) {
    errors.date = "Enter Date *";
    isError = true;
  }

  if (window.cn(paymentDate) && !window.cb(paymentDate)) {
    errors.paymentDate = "Enter Payment Received Date";
    isError = true;
  }

  serviceItemArray.forEach((item: any, index: any) => {
    if (window.cn(item.name) && !window.cb(item.name)) {
      errors[`name_${index}`] = "Enter Name*";
      isError = true;
    } else {
      errors[`name_${index}`] = "";
    }
    if (window.cn(item.hour) && !window.cb(item.hour)) {
      errors[`hour_${index}`] = "Enter Quantity / Hour*";
      isError = true;
    } else {
      errors[`hour_${index}`] = "";
    }
    if (window.cn(item.rate) && !window.cb(item.rate)) {
      errors[`rate_${index}`] = "Enter Rate*";
      isError = true;
    } else {
      errors[`rate_${index}`] = "";
    }
    // if (window.cn(item.description) && !window.cb(item.description)) {
    //   errors[`description_${index}`] = "Enter description*";
    //   isError = true;
    // } else {
    //   errors[`description_${index}`] = "";
    // }
  });

  return { errors, isError };
};

// validate client profile data
export const validateClientProfileData = (inputDetail: any) => {
  let errors: any = {};
  let isError = false;
  if (window.cn(inputDetail.company_name) && !window.cb(inputDetail.company_name)) {
    errors.company_name = "Enter Company Name *";
    isError = true;
  }
  if (window.cn(inputDetail.email) && !window.cb(inputDetail.email)) {
    errors.email = "Enter Email *";
    isError = true;
  } else if (!emailPattern.test(inputDetail.email)) {
    errors.email = "Enter Valid Email *";
    isError = true;
  }
  if (window.cn(inputDetail.postal_code) && !window.cb(inputDetail.postal_code)) {
    errors.postal_code = "Enter Postal Code *";
    isError = true;
  } else if (!postalCodePattern.test(inputDetail.postal_code)) {
    errors.postal_code = "Enter Valid Postal Code *";
    isError = true;
  }
  if (window.cn(inputDetail.phone) && !window.cb(inputDetail.phone)) {
    errors.phone = "Enter Phone *";
    isError = true;
  } else if (!phonePattern.test(inputDetail.phone)) {
    errors.phone = "Enter Valid Phone *";
    isError = true;
  }
  if (window.cn(inputDetail.address) && !window.cb(inputDetail.address)) {
    errors.address = "Enter Address *";
    isError = true;
  }
  if (window.cn(inputDetail.province) && !window.cb(inputDetail.province)) {
    errors.province = "Select Province *";
    isError = true;
  }
  if (window.cn(inputDetail.city) && !window.cb(inputDetail.city)) {
    errors.city = "Enter City *";
    isError = true;
  }

  // if (
  //   window.cn(inputDetail.client_charge) &&
  //   !window.cb(inputDetail.client_charge)
  // ) {
  //   errors.client_charge = "Enter Client Charge *";
  //   isError = true;
  // } else if (inputDetail?.client_charge > 15) {
  //   errors.client_charge = "Client Charge Must Be Less Than 15";
  //   isError = true;
  // }
  if (window.cn(inputDetail.bussiness_number) && !window.cb(inputDetail.bussiness_number)) {
    errors.bussiness_number = "Enter Business number *";
    isError = true;
  } else if (inputDetail.bussiness_number?.length != 13) {
    errors.bussiness_number = "Enter Valid Business number *";
    isError = true;
  }
  return { errors, isError };
};

// .................................... client charge payment by in user profile...........

export const validateClientChargePaymentBy = (inputDetail: any) => {
  let errors: any = {};
  let isError = false;

  if (window.cn(inputDetail.client_charge_payment_by) && !window.cb(inputDetail.client_charge_payment_by)) {
    errors.client_charge_payment_by = "Select Client Charge Payment By *";
    isError = true;
  }
  return { errors, isError };
};

// ................................... validate employee status date change ...................

export const validateEmployeStatusDate = (empStatusChangeDate: any, selectedDropdownStatus: any, roeIssuerName: any, payrollRefNo: any) => {
  let errors: any = {};
  let isError = false;

  if (selectedDropdownStatus) {
    if (!empStatusChangeDate) {
      errors.emp_status_date = selectedDropdownStatus === "Active" ? "Select Rejoining Date *" : "Select Date *";
      isError = true;
    }
  }

  if (selectedDropdownStatus && selectedDropdownStatus !== "Active") {
    if (!roeIssuerName || roeIssuerName.trim() === "") {
      errors.issuer_name = "Select ROE Issuer Name *";
      isError = true;
    }
  }

  if (selectedDropdownStatus && selectedDropdownStatus !== "Active") {
    if (!payrollRefNo || payrollRefNo.trim() === "") {
      errors.payroll_ref_no = "Enter Payroll Reference Number *";
      isError = true;
    }
  }

  return { errors, isError };
};

// ..................................... validate sin number password .................................
export const validatePasswordField = (password: any) => {
  let errors: any = {};
  let isError = false;

  // if empty or null
  if (window.cn(password) && !window.cb(password)) {
    errors.password = "Enter Password *";
    isError = true;
  }

  return { errors, isError };
};

// ....................... validate unverified user email   .............................

export const validateUnverifiedUserField = (inputDetail: any) => {
  let errors: any = {};
  let isError = false;

  // validate email
  if (window.cn(inputDetail?.email) && !window.cb(inputDetail?.email)) {
    errors.email = "Enter Email *";
    isError = true;
  } else if (!emailPattern.test(inputDetail?.email)) {
    errors.email = "Enter Valid Email *";
    isError = true;
  }

  return { errors, isError };
};
